resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*

    History

    A Singleton implementation of the HTML5 History API for backwards/forwards
    navigation of pages/actions without refreshing the page (for single page apps).

    Declarative initialization of links (before this class is instantiated): Set a
    href and data-history, data-history-disabled (optional) attribute on links. Use the
    initializeHistoryOnDocument method to process declarative links added after this
    class has been initialized.

    Programmatic initialization of links: Use the addHistoryNode method.

    Programmatic navigation to pages through goToUrl and replaceUrl methods.

    Parameters:

        defaultCallback [function]:
            Callback method when the user initiates backwards/forwards navigation.


    Methods (see methods for additional usage):

        initializeHistoryOnDocument(node)

        addHistoryNode(node, href, callback, data)

        removeHistoryNode(node)

        disableHistoryNode(node)

        enableHistoryNode(node)

        goToUrl(href, callback, data)

        replaceUrl(href, callback, data)


    Example usage:

        var h = new History(function(href, data) {
            // Default callback
            switchViews(href);
        });
*/
function History(defaultCallback) {

    this.constructor = function(defaultCallback) {
        if (typeof defaultCallback == "function")
            this.popStateCallback = defaultCallback;
        else
            this.popStateCallback = function(href, data) {};

        // Setup callback object
        this.callbackObj = new Object();

        // Setup popupstate event listener
        window.addEventListener("popstate", this._onPopState.bind(this));

        // Add click handlers to links
        this.initializeHistoryOnDocument();

        // Add a callback to all state changes
        window.addEventListener('pushstate', this._stateChangeCallback);
        window.addEventListener('popstate', this._stateChangeCallback);
    };

    this._stateChangeCallback = function() {
      // Set Scroll Position Back to the top of the page
      $('html, body').scrollTop(0);
    };

    /*
        Specify a node to use the History API.

        Arguments:
            node [HTMLElement] (required):
                The node to use the history API.

            href [string] (required):
                The URL that corresponds to the action (updated in location bar).

            callback [function] (optional):
                Method to callback when there is backwards/forwards navigation to this link.
                Uses the default callback if a callback is not specified.

            data [Object] (optional):
                Data that is passed back to the callback method.

        Returns:
            true if successful, false otherwise.
    */
    this.addHistoryNode = function(node, href, callback, data) {
        if (node instanceof HTMLElement && href != null) {
            $(node).attr("href", href);
            $(node).attr("data-history", true);
            href = node.href;
            if (typeof callback == "function")
                this.callbackObj[href] = callback;

            // Check if click.history already exists on this node
            var events = $._data(node, "events");
            if (events != null && events.click != null) {
                events = events.click;
                for (var i = 0; i < events.length; i++) {
                    if (events[i].namespace == "history")
                        return true;
                }
            }

            $(node).on("click.history", $.proxy(this._onClickHistoryLink, this, href, data));

            return true;
        }
        return false;
    };

    /*
        Specify a node to stop using the History API.

        Arguments:
            node [HTMLElement] (required):
                The node to stop using the History API.

        Returns:
            true if successful, false otherwise.
    */
    this.removeHistoryNode = function(node) {
        if (node instanceof HTMLElement) {
            if (this.callbackObj[node.href] != null)
                delete this.callbackObj[node.href];

            $(node).attr("data-history", null);
            $(node).off(".history");

            return true;
        }
        return false;
    };

    /*
        Specify a history node to disable. A disabled node will not be pushed to the
        History API.

        Arguments:
            node [HTMLElement] (required):
                The node to disable History functionality. The node must be a history
                node (data-history attribute).

        Returns:
            true if successful, false otherwise.
    */
    this.disableHistoryNode = function(node) {
        if ($(node).attr("data-history")) {
            $(node).attr("data-history-disabled", "true");
            return true;
        }
        return false;
    };

    /*
        Specify a history node to enable. An enabled node will be pushed to the
        History API.

        Arguments:
            node [HTMLElement] (required):
                The node to re-enable History functionality. The node must be a history
                node (data-history attribute).

        Returns:
            true if successful, false otherwise.
    */
    this.enableHistoryNode = function(node) {
        if ($(node).attr("data-history")) {
            $(node).removeAttr("data-history-disabled");
            return true;
        }
        return false;
    };

    /*
        Crawls the document for any data-history attributes and initializes the History API
        on those nodes. This method is automatically called on instantiation of this class.

        Arguments:
            node [HTMLElement] (optional):
                The node to crawl. Defaults to the entire document.
    */
    this.initializeHistoryOnDocument = function(node) {
        if (!(node instanceof HTMLElement))
            node = $("body")[0];

        var historyNodes = $("[data-history='true'], [data-history]", node).not("[data-history='false']");
        for (var i = 0; i < historyNodes.length; i++) {
            var link = historyNodes[i];
            this.addHistoryNode(link, link.href, null, null);
        }
    };

    /*
        Navigate to a URL and save the current one in history.

        Arguments:
            href [string] (required):
                The URL that corresponds to the action (updated in location bar).

            callback [function] (optional):
                Method to callback when there is backwards/forwards navigation to this link.
                Uses the default callback if a callback is not specified.

            data [Object] (optional):
                Data that is passed back to the callback method.


        Returns:
            true if successful.
    */
    this.goToUrl = function(href, callback, data) {
        history.pushState(data, null, href);
        try {
            window.dispatchEvent(new Event('pushstate'));
        } catch (e) {
            var historyEvent = document.createEvent("Event");
            historyEvent.initEvent('pushstate', true, true);
            window.dispatchEvent(historyEvent);
        }
        if (typeof callback == "function")
            this.callbackObj[location.href] = callback;
        return true;
    };

    /*
        Replace the current URL with a new one. The replaced URL is not saved in history.

        Arguments:
            href [string] (required):
                The URL that corresponds to the action (updated in location bar).

            callback [function] (optional):
                Method to callback when there is backwards/forwards navigation to this link.
                Uses the default callback if a callback is not specified.

            data [Object] (optional):
                Data that is passed back to the callback method.


        Returns:
            true if successful.
    */
    this.replaceUrl = function(href, callback, data) {
        history.replaceState(data, null, href);
        try {
            window.dispatchEvent(new Event('pushstate'));
        } catch (e) {
            var historyEvent = document.createEvent("Event");
            historyEvent.initEvent('pushstate', true, true);
            window.dispatchEvent(historyEvent);
        }

        if (typeof callback == "function")
            this.callbackObj[location.href] = callback;
        return true;
    };

    this._onClickHistoryLink = function(href, data, evt) {
        if ($(evt.currentTarget).attr("data-history-disabled"))
            return false;
        history.pushState(data, null, href);
        try {
            window.dispatchEvent(new Event('pushstate'));
        } catch (e) {
            var historyEvent = document.createEvent("Event");
            historyEvent.initEvent('pushstate', true, true);
            window.dispatchEvent(historyEvent);
        }

        return false;
    };

    this._onPopState = function(evt) {
        var href = location.href;
        if (this.callbackObj[href] != null)
            this.callbackObj[href](location.href, evt.state);
        else
            this.popStateCallback(location.href, evt.state);
    };

    // Singleton
    window.mogo = window.mogo || {};
    window.mogo.registry = window.mogo.registry || {};
    if (window.mogo.registry.History == null) {
        window.mogo.registry.History = this;
        this.constructor(defaultCallback);
    }
    return window.mogo.registry.History;
}
